var React = require('react');

function IconHtmlImage (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M12.08333 10H1.25C.55964 10 0 9.44036 0 8.75v-7.5C0 .55964.55964 0 1.25 0h10.83333c.69037 0 1.25.55964 1.25 1.25v7.5c0 .69036-.55963 1.25-1.25 1.25zM2.91667 1.45833c-.80542 0-1.45834.65292-1.45834 1.45834 0 .80541.65292 1.45833 1.45834 1.45833.80541 0 1.45833-.65292 1.45833-1.45833 0-.80542-.65292-1.45834-1.45833-1.45834zm-1.25 6.875h10V5.41667L9.38763 3.13763c-.12203-.12203-.3199-.12203-.44195 0L5.41667 6.66667l-1.4457-1.4457c-.12204-.12204-.3199-.12204-.44196 0L1.66667 7.08332v1.25z"}));
}

IconHtmlImage.defaultProps = {"viewBox":"0 0 14 10"};

module.exports = IconHtmlImage;

IconHtmlImage.default = IconHtmlImage;
